
import { Course } from '../types';

export const co_parenting_skills: Course = {
  id: "co_parenting_skills",
  title: "Co-Parenting Skills",
  description: "Practical communication and handover skills for separated dads.",
  icon: "📱",
  totalModules: 9,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/co_parenting_skills/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to the 'Operating Child Inc.' principle, what is the single most important objective in collaborative parenting?",
        "o": [
            "To ensure parents always agree on all decisions",
            "To minimize financial contributions from one parent",
            "The child's wellbeing and future",
            "To legally prove one parent is better than the other"
        ],
        "a": 2
    },
    {
        "q": "What is the primary purpose of 'The 24-Hour Rule' in the communications protocol?",
        "o": [
            "To ensure quick replies to all messages",
            "To avoid replying to provocative messages while angry or emotional",
            "To schedule replies only during business hours",
            "To forward all messages to a legal advisor"
        ],
        "a": 1
    },
    {
        "q": "When communicating with a co-parent, the BIFF Method requires messages to be all of the following EXCEPT:",
        "o": [
            "Brief",
            "Informative",
            "Friendly",
            "Opinionated"
        ],
        "a": 3
    },
    {
        "q": "What is the recommended 'Exit Strategy' during a handover if a conflict or fight begins?",
        "o": [
            "Engage in the discussion in front of the child to resolve it immediately",
            "Walk away immediately and never engage in front of the child",
            "Call a mediator to join the discussion at the doorstep",
            "Insist on finishing the conversation before leaving"
        ],
        "a": 1
    },
    {
        "q": "According to 'Building Emotional Capital Through Strategic Flexibility,' why is it beneficial to say 'yes' to reasonable requests for schedule swaps?",
        "o": [
            "It proves you are always available for any changes",
            "It builds emotional capital and demonstrates a child-focused approach to a judge",
            "It ensures the other parent will always say yes to your requests",
            "It is legally required in all co-parenting agreements"
        ],
        "a": 1
    }
]
};
